import { Loader } from "../../loader/index.js";
import { defineBuiltins } from "../builtins/defineBuiltins.js";
import { createChecking } from "../checking/createChecking.js";
import { createEnv } from "../env/createEnv.js";
import {} from "../stmt/index.js";
import {} from "./Mod.js";
export function createMod(options) {
    const mod = {
        loader: options.loader,
        url: options.url,
        text: options.text,
        stmts: options.stmts,
        definitions: new Map(),
        builtins: new Map(),
        ruleEntries: new Map(),
        requiredMods: new Map(),
    };
    mod.env = createEnv(mod);
    mod.checking = createChecking();
    defineBuiltins(mod);
    return mod;
}
//# sourceMappingURL=createMod.js.map